import { Injectable } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";
import { GenericComponent } from "./generic-component";

declare var $: any;
declare function toAnchor(toLink): any;

@Injectable()

export class GenericFormCarouselComponent extends GenericComponent {

    _formGroup: UntypedFormGroup;
    isLoadingRequest: boolean = false;
    isLoadingPage: boolean = true;

    public showPasswordConfirm = false;
    public showPassword = false;
    public response: any = {};

    public progressFile: { percentage: number } = { percentage: 0 }

    constructor(private carouselName: string) {
        super();
    }

    validateStepInputData() {
        this._formGroup.markAllAsTouched();

        if (this._formGroup.invalid) return;

        this.nextStepCarousel();
    }

    validateStepInputDataScroll(event: PointerEvent): void {
        event.preventDefault();
        this.validateStepInputData();
        this.scrollToFirstInvalidControl();
    }

    scrollToFirstInvalidControl() {

        if (this._formGroup.valid) return;

        const firstInvalidControl: HTMLElement = document.querySelector("fieldset .ng-invalid, fieldset .data-required");

        
        if (firstInvalidControl === null)
            return;

        const labelOffset = firstInvalidControl.parentElement.getBoundingClientRect().top + window.scrollY - 80;

        window.scroll({
            top: labelOffset,
            left: 0,
            behavior: "smooth"
        });

        firstInvalidControl.focus({ preventScroll: true });
    }

    isValidFormGroupModal() {
        this._formGroup.markAllAsTouched();

        if (this._formGroup.invalid) return false;

        return true;
    }

    setDataError(err: any) {

        this.response = err;
        this.showStepError();
        this.isLoadingRequest = false;
        console.log(err);
    }

    setDataResponse() {
        this.response = {};
        this.showStepSuccess();

        setTimeout(() => {
            this.isLoadingRequest = false;
        }, 200);
    }

    nextStepCarousel() {
        setTimeout(function () {
            var anchorFormCarousel = $('a[name="formCarousel"]');
            if (0 < anchorFormCarousel.length) {
                toAnchor('formCarousel');
            }
        }, 400);
        $("#".concat(this.carouselName)).carousel("next");
    }

    prevStepCarousel() {
        setTimeout(function () {
            var anchorFormCarousel = $('a[name="formCarousel"]');
            if (0 < anchorFormCarousel.length) {

                toAnchor('formCarousel');
            }
        }, 400);
        $("#".concat(this.carouselName)).carousel("prev");
    }

    resetStepCarousel() {
        $("#".concat(this.carouselName)).carousel(0);
        $('.form-steps .step').removeClass('ok active');
        $('.form-steps .step:first').addClass('active');
        this.isLoadingRequest = false;
    }

    setStepCarousel(stepNumber: number) {
        $("#".concat(this.carouselName)).carousel(stepNumber);
        $('.form-steps .step').removeClass('ok active');
        $('.form-steps .step:first').addClass('active');
    }


    showStepSuccess() {
        $("#".concat(this.carouselName)).carousel($("#".concat(this.carouselName, " .successSlide")).index());
        $('.form-steps .step:not(:last-child').addClass('ok').removeClass('active');
        $('.form-steps .step:last-child').addClass('active').removeClass('ok');

        setTimeout(() => {
            this.isLoadingRequest = false;
        }, 200);

    }

    showStepError(message = {}) {
        this.response = message;
        $("#".concat(this.carouselName)).carousel($("#".concat(this.carouselName, " .errorSlide")).index());
        $('.form-steps .step:not(:last-child').addClass('ok').removeClass('active');
        $('.form-steps .step:last-child').addClass('active').removeClass('ok');
        this.isLoadingRequest = false;
    }

    showStepByClassName(className: string) {
        $("#".concat(this.carouselName)).carousel($("#".concat(this.carouselName, " ." + className + "")).index());
        $('.form-steps .step:not(:last-child').addClass('ok').removeClass('active');
        $('.form-steps .step:last-child').addClass('active').removeClass('ok');
        this.isLoadingRequest = false;
    }

    regenerateCarousel() {
        $("#".concat(this.carouselName)).carousel({
            interval: false,
            touch: false,
            keyboard: false,
            ride: false
        });

        setTimeout(() => {
            $(`#${this.carouselName} .carousel-item`).removeClass('active');
            $(`#${this.carouselName} .carousel-item:first`).addClass('active');
            $("#".concat(this.carouselName)).carousel(0);
        }, 0);
    }

    passwordShowConfirm() {
        this.showPasswordConfirm = !this.showPasswordConfirm;
    }

    passwordShow() {
        this.showPassword = !this.showPassword;
    }
}
